import { useBoardService, useBoardStore } from 'src/features/boards';

import { BoardSlice, CreateBoardSlice } from '../types';

export const createBoardSlice: CreateBoardSlice = (set, get): BoardSlice => ({
  boardId: '',
  isReadOnly: false,
  isPublicView: false,
  fetchBoard: async () => {
    const state = get();
    const filtered: any = useBoardStore.getState().filters.filter((obj) => !!obj.property);
    const board = await useBoardService().fetchBoardDetails({
      id: state.boardId,
      isPublicView: state.isPublicView,
      filters: filtered,
    });

    if (board) {
      set((s) => {
        s.isLoading = false;
      });
      set((s) => {
        return { ...s, ...board };
      });
    }
  },
});
